import { render, staticRenderFns } from "./BulkPromotion.vue?vue&type=template&id=93378254&scoped=true"
import script from "./BulkPromotion.vue?vue&type=script&lang=js"
export * from "./BulkPromotion.vue?vue&type=script&lang=js"
import style0 from "./BulkPromotion.vue?vue&type=style&index=0&id=93378254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93378254",
  null
  
)

export default component.exports